<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="27.671" height="19.5" viewBox="0 0 27.671 19.5">
    <g id="Gruppe_32" transform="translate(-152.619 -255.891)">
      <path id="Pfad_40" d="M187.676,260.474a1.475,1.475,0,0,1-1.474,1.474H170.474a1.474,1.474,0,0,1,0-2.949H186.2A1.475,1.475,0,0,1,187.676,260.474Z" transform="translate(-8.136 -2.052)" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <path id="Pfad_41" d="M187.676,288.474a1.475,1.475,0,0,1-1.474,1.474H170.474a1.474,1.474,0,0,1,0-2.949H186.2A1.475,1.475,0,0,1,187.676,288.474Z" transform="translate(-8.136 -16.291)" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <path id="Pfad_42" d="M187.676,274.474a1.475,1.475,0,0,1-1.474,1.474H170.474a1.474,1.474,0,1,1,0-2.949H186.2A1.475,1.475,0,0,1,187.676,274.474Z" transform="translate(-8.136 -9.171)" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <circle id="Ellipse_9" cx="2" cy="2" r="2" transform="translate(153.369 256.641)" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <circle id="Ellipse_10" cx="2" cy="2" r="2" transform="translate(153.369 270.641)" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <circle id="Ellipse_11" cx="2" cy="2" r="2" transform="translate(153.369 263.641)" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
    </g>
  </svg>

</template>

<script>
export default {
  name: "category"
}
</script>

<style scoped>

</style>